const circlesOrbitColorPalette = {
  primary: {
    disabled: '#A4AAFF', //shy moment, lighter blue
    light: '#0000FF', //blue
    main: '#0015C4', //primary base medium blue
    dark: '#000869' // primary, 20% darker dark imperial blue'
  },
  accent: {
    main: '#DF46F5', //pink
    secondary: '#8700DC', //dark violet
    yellow: '#EFC100'
  },
  toolkit: {
    main: '#E8E9FD' //light blue
  },
  error: {
    main: '#BD1144' //Pictorial Carmine
  },
  success: {
    main: '#008189',
    secondary: '#44BA1B' //Teal
  },
  note: {
    main: '#3DA9FC', //Blue
    light: '#E7F5FF' //Alice blue
  },
  text: {
    main: '#333333', //gray20
    secondary: '#7B8794', //light slate gray
    light: '#CBD2D9'
  },
  //increasing intensity
  neutrals: {
    main: '#717477', //light grayish blue
    light: '#F0F0F0', //white smoke
    background: '#eceef6', //ghost white
    background2: '#f9f9f9',
    0: '#fcfdfd', //Maui Mist
    100: '#f1f4f7',
    200: '#e2e8ee',
    300: '#b5babe',
    400: '#9ea2a7',
    500: '#888b8f',
    600: '#717477',
    700: '#5a5d5f',
    800: '#444647',
    900: '#171718'
  }
}

export default circlesOrbitColorPalette
